import { Box, Typography } from '@mui/material';
import expiredLinkScreen from "../../../../assets/externalApplicationImages/expiredLinkScreen.png";

interface IProps{
    subText1: string;
    subText2: string;
}

export const ExpiredLinkScreen = (props : IProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "100px"
            }}
        >
            <img
                src={expiredLinkScreen}
                alt="Expired Link"
                style={{ height: "300px", width: "320px" }}
            />
            <Typography variant="h4" style={{paddingTop: "10px"}}>
                {props.subText1}
            </Typography>
            <Typography variant="body2" color="secondary" style={{paddingTop: "10px"}}>
                {props.subText2}
            </Typography>
        </Box>
    );
}
